import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../common/selectCurrencyUnit/slice'
import peerAnalysisService from '../../../store/peerAnalysisService'

export const getFinancialStatements = createAsyncThunk(
  'companyAnalysis/peerAnalysis/getFinancialStatements',
  async (params, { rejectWithValue, dispatch }) => {
    const response = await peerAnalysisService.getFinancialStatements(params)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.PEER_ANALYSIS,
          getValues: () =>
            response.data
              .map((item) => [
                ...item.balanceSheets,
                ...item.cashFlows,
                ...item.incomeStatements,
              ])
              .flat()
              .map((item) => ({
                value: item.value,
                year: params.realYear,
                exchangeRateType: item.exchangeRateType,
              })),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const getYearReports = createAsyncThunk(
  'peerAnalysis/getYearReports',
  async (params, { rejectWithValue }) => {
    try {
      const res = await peerAnalysisService.getYearReports(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
